module.exports = __webpack_public_path__ + "static/media/9H.71f25336.svg";